import React, { useState } from 'react';
import { IStandardDocumentVersionData } from 'types/order/documents/shared/interfaces';
import { ShareableLinkModal } from './ShareableLinkModal';
import { MergeDocumentForm } from './MergeDocumentForm';
import { StandardDocumentsTable } from './StandardDocumentsTable';
import { IStandardDocumentsPageProps } from 'pages/order/documentsPortal/StandardDocumentsPage';
import { DragAndDropContainer } from './uploadDocuments/DragAndDropContainer';
import {
  defaultNormalizedDocumentCategoriesData,
  useListDocumentCategoriesQuery,
} from '../../../../API/documentCategories/DocumentCategoriesApi';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../../types/shared/UUID';

export const StandardDocumentsTableAndMerge: React.FC<IStandardDocumentsPageProps> = ({
  documents,
  documentsActionError,
  documentsActionFetchStatus,
  editDocumentFetch,
  isAmericanDigital,
  onCloseMerge,
  onDeleteDocumentReset,
  onEditDocumentReset,
  onEditDocument,
  onFundingClick,
  onGenerateLink,
  onMergeDocuments,
  onPublish,
  onResetGenerateLink,
  onSigningClick,
  onUnpublish,
  onUploadDocuments,
  parties,
  postGenerateLink,
  users,
  onFinalizeDocument,
  resetFinalDocumentForm,
  onCloseFinalizeModal,
  categories,
  onDetailsClick,
  onCloseDetailsSideSheet,
  isZDocLoading,
}) => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const [showGenerateLinkModal, setShowGenerateLinkModal] = useState<IStandardDocumentVersionData | null>(null);
  const [searchValue, setSearchValue] = useState<string | null>(null);
  const [showAddDocumentModal, setShowAddDocumentModal] = useState<boolean>(false);

  const { data: { documentCategoriesByName } = defaultNormalizedDocumentCategoriesData } =
    useListDocumentCategoriesQuery();
  const getCategoryLabel = (categoryName: string): string | undefined => documentCategoriesByName[categoryName]?.label;
  const filteredDocuments = documents.filter((doc) => {
    const prettyCategory = getCategoryLabel(doc.category);
    return (
      prettyCategory?.toLowerCase().includes((searchValue || '').toLowerCase()) ||
      doc.fileName.toLowerCase().includes((searchValue || '').toLowerCase())
    );
  });

  return (
    <>
      {showGenerateLinkModal && (
        <ShareableLinkModal
          onClose={() => {
            setShowGenerateLinkModal(null);
            onResetGenerateLink();
          }}
          standardDocument={showGenerateLinkModal}
          onGenerateLink={onGenerateLink}
          postGenerateLink={postGenerateLink}
        />
      )}

      <MergeDocumentForm
        documents={documents}
        orderId={orderId}
        onSubmit={onMergeDocuments}
        onClose={onCloseMerge}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        setShowAddDocumentModal={setShowAddDocumentModal}
      >
        <DragAndDropContainer
          showAddDocumentModal={showAddDocumentModal}
          onUploadDocuments={onUploadDocuments}
          orderId={orderId}
          setShowAddDocumentModal={setShowAddDocumentModal}
          standardDocumentCategories={categories}
        >
          <StandardDocumentsTable
            categories={categories}
            documents={filteredDocuments}
            documentsActionError={documentsActionError}
            documentsActionFetchStatus={documentsActionFetchStatus}
            editDocumentFetch={editDocumentFetch}
            isAmericanDigital={isAmericanDigital}
            onDeleteDocumentReset={onDeleteDocumentReset}
            onEditDocument={onEditDocument}
            onEditDocumentReset={onEditDocumentReset}
            onFundingClick={onFundingClick}
            onPublish={onPublish}
            onSigningClick={onSigningClick}
            onUnpublish={onUnpublish}
            parties={parties}
            setShowGenerateLinkModal={setShowGenerateLinkModal}
            users={users}
            onFinalizeDocument={onFinalizeDocument}
            resetFinalDocumentForm={resetFinalDocumentForm}
            onCloseFinalizeModal={onCloseFinalizeModal}
            onDetailsClick={onDetailsClick}
            onCloseDetailsSideSheet={onCloseDetailsSideSheet}
            isZDocLoading={isZDocLoading}
          />
        </DragAndDropContainer>
      </MergeDocumentForm>
    </>
  );
};
